import { render, staticRenderFns } from "./ReportActivity.vue?vue&type=template&id=5ca16950&scoped=true&"
import script from "./ReportActivity.vue?vue&type=script&lang=js&"
export * from "./ReportActivity.vue?vue&type=script&lang=js&"
import style0 from "./ReportActivity.vue?vue&type=style&index=0&id=5ca16950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca16950",
  null
  
)

export default component.exports